import * as yup from 'yup';

export const addInvoiceValidationSchema = yup.object({
  description: yup.string().required('A description is required'),
  siteId: yup.string().required('A site is required'),
  editorId: yup.string().required('An editor is required'),
  type: yup.string().required('An invoice type is required'),
  date: yup.string().required('A date is required'),
  amount: yup.number().required('An amount is required'),
});
